import { Platform } from 'react-native';
import * as SecureStore from 'expo-secure-store';
import { router } from 'expo-router';

import { BeroClient, type TokenStore } from '@bero/api-client';

const webStore: TokenStore = {
  get: async (k) => (typeof localStorage === 'undefined' ? null : localStorage.getItem(k)),
  set: async (k, v) => { localStorage.setItem(k, v); },
  del: async (k) => { localStorage.removeItem(k); },
};

const nativeStore: TokenStore = {
  get: (k) => SecureStore.getItemAsync(k.replace(/[^A-Za-z0-9._-]/g, '_')),
  set: (k, v) => SecureStore.setItemAsync(k.replace(/[^A-Za-z0-9._-]/g, '_'), v),
  del: (k) => SecureStore.deleteItemAsync(k.replace(/[^A-Za-z0-9._-]/g, '_')),
};

/**
 * Resolution order:
 * 1. EXPO_PUBLIC_API_URL (dev override / CI)
 * 2. web: same-origin behind Apache in production, localhost API in local dev
 * 3. native: production API. Hardcoded ON PURPOSE — OTA bundles (`eas update`)
 *    do NOT read eas.json build env, so an env-only setup ships updates with
 *    no API URL and native silently falls back to the phone's own localhost
 *    (that was OTA #1's login outage). __DEV__ keeps local dev pointing home.
 */
export const API_URL =
  process.env.EXPO_PUBLIC_API_URL ??
  (Platform.OS === 'web'
    ? (typeof location !== 'undefined' && location.hostname !== 'localhost' ? '' : 'http://127.0.0.1:5001')
    : __DEV__ ? 'http://127.0.0.1:5001' : 'https://api.usebero.com');

export const api = new BeroClient(
  API_URL,
  Platform.OS === 'web' ? webStore : nativeStore,
  () => router.replace('/login'),
);
